<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Comité de convivencia laboral",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
       
        {
          text: "Comité de convivencia laboral",
          active: true,
        },
      ],
      text: `
         ... `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Vuelve a la página anterior real. Esta vista se abre tanto desde la base
     * de conocimiento como desde su ítem, así que no se puede fijar el destino.
     * Si no hay historial (entrada directa o refresh) cae a la base de conocimiento.
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push("/forms/general");
      }
    },

    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Comité de convivencia laboral</h4>
              </div>

              <div class="col-6 text-right">
                <button type="button" class="btn btn-secondary m-l-5 ml-1" id="tooltip" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>
            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                  <b-list-group-item href="#list-item-1"
                    >¿Qué es el comité de convivencia?  </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >¿Qué norma fue derogada por la Resolución 3461 de 2025?  </b-list-group-item
                  >
                  <b-list-group-item href="#list-item-3"
                    >¿Cómo se conforma el comité de convivencia?  </b-list-group-item
                  >
                    <b-list-group-item href="#list-item-4"
                    >¿Cada cuánto se reúnen los integrantes del Comité de Convivencia?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-5"
                    >¿Cuáles son las funciones del Comité de Convivencia?</b-list-group-item
                  >
                 <!--  <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <h4 id="list-item-1">¿Qué es el comité de convivencia</h4>
                   <p>La Resolución 3461 de 2025 del Ministerio del Trabajo (Colombia) establece que el Comité de Convivencia Laboral es una instancia interna que se conforma en las entidades públicas y empresas privadas con el objetivo de
                     prevenir, orientar, conciliar y canalizar situaciones de conflicto y acoso laboral entre trabajadores y empleadores. Esta norma define: <br /><br />

                    · Su conformación: integrado por representantes del empleador y de los trabajadores, con suplentes y reglas de composición según el número de personas en la organización.<br /><br />

                    · Su función: actuar como mecanismo preventivo, orientador y conciliador para abordar quejas de acoso laboral y conflictos de convivencia, con plazos máximos para el trámite de quejas y fases claras de recepción, diálogo y seguimiento.<br /><br />

                    · Límites de competencia: no es competente para casos de acoso sexual, los cuales deben ser atendidos mediante procedimientos específicos por la organización, dado que estas conductas no son conciliables en este Comité.<br /><br />

                    · Responsabilidades: define obligaciones para empleadores y Administradoras de Riesgos Laborales (ARL) en prevención, formación y acciones contra riesgos psicosociales.<br /><br />

                  En síntesis, es una estructura interna de gestión y prevención de conflictos laborales, con procedimientos definidos para mejorar la convivencia en el trabajo y minimizar el acoso laboral.<br /><br />

                  
                  </p>
                  <h4 id="list-item-2">¿Qué norma fue derogada por la Resolución 3461 de 2025?</h4>
                  <p>La Resolución 3461 de 2025 deroga expresamente las siguientes normas sobre el mismo tema:<br /><br />

                  ✔️ Resolución 652 de 2012 ✔️ Resolución 1356 de 2012

                  Estas resoluciones antiguas establecían los lineamientos para la conformación y funcionamiento del Comité de Convivencia Laboral, pero fueron sustituidas por la nueva regulación más completa y actualizada en materia de convivencia y acoso laboral. <br /><br />

                  </p>
                  <h4 id="list-item-3">¿Cómo se conforma el comité de convivencia?  </h4>
                  <p>El comité se compone de representantes del empleador y de los trabajadores, con sus respectivos suplentes, y debe mantener igualdad en el número de representantes de cada parte. La conformación depende del número de trabajadores:<br /><br />

                    · Menos de 5 trabajadores: 1 representante del empleador y 1 de los trabajadores.<br /><br />

                    · Entre 5 y 20 trabajadores: 1 representante del empleador y 1 de los trabajadores con suplentes.<br /><br />

                    · Más de 20 trabajadores: 2 representantes del empleador y 2 de los trabajadores con suplentes.<br /><br />

                  Además, si la empresa tiene dos o más centros de trabajo, debe conformar comités según su estructura interna (por ejemplo, uno central y otros por cada centro).   </p><br /><br />
                  <h4 id="list-item-4">¿Cada cuánto se reúnen los integrantes del Comité de Convivencia?</h4>
                  <p>La normativa no fija un número exacto obligatorio de reuniones ordinarias en la resolución misma, pero el comité debe reunirse con una frecuencia mínima de forma periódica (por lo general se interpreta como mensual) para hacer seguimiento de casos y compromisos asumidos. También se reúne en forma extraordinaria cada vez que se recibe una queja o solicitud de atención. </p>
                  <h4 id="list-item-5">¿Cuáles son las funciones del Comité de Convivencia?</h4>
                  <p><h5>Funciones principales:</h5>

                    ✔ Recibir, tramitar y analizar quejas relacionadas con posibles conflictos o conductas que afecten la convivencia. <br /><br />
                    ✔ Escuchar a las partes involucradas de forma confidencial e imparcial. <br /><br />
                    ✔ Fomentar el diálogo y la conciliación entre las personas implicadas. <br /><br />
                    ✔ Proponer soluciones y compromisos que faciliten la convivencia laboral. <br /><br />
                    ✔ Hacer seguimiento periódico a los acuerdos alcanzados. <br /><br />
                    ✔ Remitir casos a la autoridad competente si no se logra acuerdo o la conducta persiste.<br /><br />

                  Importante: El comité tiene carácter preventivo, orientador, conciliador y canalizador, pero no decide si legalmente existe acoso laboral.  <br /><br />
                    <br/><br /><br /><br /><br /><br /><br /><br /> </p>
                 <!-- <h4 id="list-item-3">DEFINICIONES</h4>
                  <p>...</p>
                  <h4 id="list-item-4">ACTIVIDADES</h4>
                  <p>...</p>
                 <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
